import styled, { keyframes } from 'styled-components';
import { COLOR } from '@src/styles/color';
import {
  MEDIA_TRACK_HEIGHT,
  TRACK_HEIGHT,
  WAVEFORM_HEIGHT,
} from '@src/constants/timeline';

export const StyledLane = styled.div`
  position: relative;
  width: 100%;
  height: ${MEDIA_TRACK_HEIGHT}px;
`;

// Read-only clip fitted to the video: a frame band stacked over a waveform band.
export const StyledMediaClip = styled.div`
  position: absolute;
  top: 0;
  height: ${MEDIA_TRACK_HEIGHT}px;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  overflow: hidden;
  background: ${COLOR.indigo[8]};
  border: 0.5px solid ${COLOR.indigo[16]};
`;

// Top band — the video frames (or the fallback icon, centered).
export const StyledFrameBand = styled.div`
  position: relative;
  height: ${TRACK_HEIGHT}px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

// Bottom band — a white strip under the frames, reserved for the audio
// waveform drawn into it later.
export const StyledWaveBand = styled.div`
  position: relative;
  height: ${WAVEFORM_HEIGHT}px;
  background: ${COLOR.white};
  border-top: 0.5px solid ${COLOR.indigo[16]};
  overflow: hidden;
`;

export const StyledMediaIcon = styled.span`
  display: inline-flex;
  color: ${COLOR.indigo[32]};

  svg {
    font-size: 20px;
  }
`;

// Frames are absolutely positioned (left/width inline) so only visible tiles mount.
export const StyledFilmstrip = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const StyledFrame = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`;

const shimmer = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

// Placeholder for a frame cell not yet extracted — a subtle shimmer.
export const StyledSkeleton = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  background: linear-gradient(
    90deg,
    ${COLOR.indigo[8]} 25%,
    ${COLOR.indigo[16]} 50%,
    ${COLOR.indigo[8]} 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;
`;

// Shown in the wave band while the audio is still decoding, so it doesn't sit
// empty — a centered shimmer strip standing in for the waveform to come.
export const StyledWaveSkeleton = styled.div`
  position: absolute;
  inset: 20% 4px;
  border-radius: 2px;
  background: linear-gradient(
    90deg,
    ${COLOR.indigo[8]} 25%,
    ${COLOR.indigo[16]} 50%,
    ${COLOR.indigo[8]} 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;
`;
